import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import classes from "../SelectSources/SelectSources.module.css";
import logo from "../../assets/images/LightLogo.webp";
import { HiArrowLeft } from "react-icons/hi2";
import { Card, Col, Row, Image, notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { fetchSourcesByCountry } from "../../redux/actions/sourcesActions";
import { selectAuthenticated } from "../../redux/slices/authSlice";
import { loginAnonymously } from "../../redux/actions/auth";
import Vector from "../../assets/images/Vector.png";

const SelectState: React.FC = () => {
  const isAuthenticated = useSelector(selectAuthenticated);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const [country, setCountry] = useState<string>(
    localStorage.getItem("country") || "",
  );

  const countries = [
    {
      value: "KS",
      flag: "https://cdn.britannica.com/18/114418-050-E12B5707/Flag-Kosovo.jpg",
      alt: "Kosova",
      name: "Kosovë",
    },
    {
      value: "AL",
      flag: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRC3oC2fAPycTMRBwivt_59S07mU48t--9m8Q&s",
      alt: "Shqiperia",
      name: "Shqipëri",
    },
  ];

  useEffect(() => {
    const fetchData = () =>
      dispatch(fetchSourcesByCountry()).catch(console.error);

    const savedCountry = localStorage.getItem("country");
    const savedSources = localStorage.getItem("selectedSources");

    if (savedCountry !== country || !savedSources) {
      if (isAuthenticated) {
        fetchData();
      } else {
        dispatch(loginAnonymously()).then(fetchData).catch(console.error);
      }
    }
  }, [country, dispatch, isAuthenticated]);

  const handleCountryClick = (value: string) => {
    setCountry(value);
    localStorage.setItem("country", value);
  };

  const onContinueHandler = () => {
    if (!country) {
      notification.warning({
        message: "Ju lutem zgjedhni një shtet",
        placement: "bottomRight",
        duration: 1.2,
      });
      return;
    }

    localStorage.setItem("country", country);
    navigate("/lajmet");

    notification.success({
      message: "Ruajtur me sukses!",
      placement: "bottomRight",
      duration: 1,
      className: "customNotification",
    });
  };

  const goToSourcesHandler = () => navigate("/selectsources");

  return (
    <div className={classes.mainDiv1}>
      <Row>
        <Col span={24} className={classes.headerDiv}>
          <div
            className={classes.backTitle}
            onClick={() => navigate("/lajmet")}
          >
            <div className={classes.circleButton}>
              <HiArrowLeft fontSize="1.2rem" color="white" />
            </div>
            <h2>Rikthehuni ne faqe</h2>
          </div>
        </Col>
      </Row>

      <Row justify="center" className={classes.centerDiv}>
        <Col span={18} className={classes.centerDivHeader}>
          <div className={classes.headerLogo}>
            <img src={logo} alt="logoImage" className={classes.stateLogo} />
          </div>
          <h2>Zgjedhni shtetin për lajme</h2>
        </Col>
      </Row>

      <Row className={classes.centerDiv}>
        <Col
          xs={20}
          sm={14}
          md={10}
          lg={6}
          className={classes.selectSourcesDivv}
        >
          {countries.map((card) => (
            <Card
              key={card.value}
              onClick={() => handleCountryClick(card.value)}
              style={{
                marginBottom: "16px",
                backgroundColor: country === card.value ? "#2D60E3" : "#242424",
                borderRadius: "0.2rem",
                border: "none",
                height: "3rem",
                padding: "1rem",
                cursor: "pointer",
                transition: "background-color 0.3s",
              }}
              bodyStyle={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                padding: "10px",
              }}
            >
              <div className={classes.sourceSection}>
                <Image
                  preview={false}
                  width="2rem"
                  height="2rem"
                  src={card.flag}
                  alt={card.alt}
                  style={{ borderRadius: "50%", objectFit: "cover" }}
                />
                <h4 style={{ color: "white" }}>{card.name}</h4>
              </div>
            </Card>
          ))}
        </Col>
      </Row>

      {country && (
        <Row className={classes.centerDivHeader}>
          <Col span={18}>
            <div className={classes.secondDivHeader}>
              <span
                className={classes.headerWithIcon}
                onClick={goToSourcesHandler}
                style={{ cursor: "pointer" }}
              >
                <h3
                  style={{
                    fontSize: "25px",
                    fontWeight: 700,
                    color: "white",
                    marginTop: "10px",
                    marginBottom: "11px",
                  }}
                >
                  Zgjedhni burimin e lajmeve
                </h3>
                <img
                  src={Vector}
                  alt="Arrow"
                  className={classes.responsiveIcon}
                />
              </span>
            </div>
          </Col>
        </Row>
      )}

      <Row className={classes.confirmSection}>
        <Col span={6}>
          <Card
            onClick={onContinueHandler}
            className={classes.confirmCard}
            bodyStyle={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              padding: "10px",
            }}
          >
            <div className={classes.confirmButton}>
              <h4 style={{ color: "white" }}>Ruaj</h4>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default SelectState;
